import { createRouter, createWebHistory } from 'vue-router'
import HomeWorkspace from '../views/HomeWorkspace.vue'
import ForumWorkspace from '../views/ForumWorkspace.vue'
import AccountWorkspace from '../views/AccountWorkspace.vue'
import CompareWorkspace from '../views/CompareWorkspace.vue'
import AccelAdmin from '../views/AccelAdmin.vue'
import ArticlesWorkspace from '../views/ArticlesWorkspace.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import AgentDesktop from '../views/AgentDesktop.vue'
import NotFound from '../views/NotFound.vue'
import { sessionRole } from '../utils/session'

const routes = [
  { path: '/', name: 'Home', component: HomeWorkspace },
  { path: '/price', redirect: (to) => ({ path: '/', query: { mode: to.query.mode === 'bom' ? 'bom' : 'price' } }) },
  { path: '/bid', redirect: (to) => ({ path: '/', query: { mode: 'bid', ...(to.query.job ? { job: String(to.query.job) } : {}) } }) },
  { path: '/advise', redirect: (to) => ({ path: '/', query: { mode: 'advise', ...(to.query.job ? { job: String(to.query.job) } : {}) } }) },
  { path: '/forum', name: 'Forum', component: ForumWorkspace },
  { path: '/articles', name: 'Articles', component: ArticlesWorkspace },
  { path: '/articles/:slug', name: 'ArticleDetail', component: ArticleDetail },
  { path: '/agent', name: 'AgentDesktop', component: AgentDesktop },
  { path: '/desktop', redirect: '/agent' },
  { path: '/account', name: 'Account', component: AccountWorkspace },
  { path: '/compare', name: 'Compare', component: CompareWorkspace },
  {
    path: '/accel-admin',
    name: 'AccelAdmin',
    component: AccelAdmin,
    meta: { adminOnly: true }
  },
  { path: '/accel-cards', redirect: '/' },
  { path: '/accel-cards/:vendor/:model', redirect: '/' },
  { path: '/library', redirect: '/' },
  { path: '/library/:id', redirect: '/' },
  { path: '/roadmap', redirect: '/' },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  if (!to.meta.adminOnly) return true
  const role = sessionRole()
  // 访客 / 注册用户不得进入管理页；未登录可看管理密码表单
  if (role === 'visitor' || role === 'user') {
    return { path: '/', query: { denied: 'admin' } }
  }
  return true
})

export default router
